import { useNavigate } from "react-router-dom";
import { Button } from "@mui/material";
import wave from "@src/shared/assets/header copy 2.png";
import logo from "@src/shared/assets/logo_1.png";
import { useEffect } from "react";
import { reachGoal } from "@src/shared/lib/analytics/yandex/reachGoal";
import { YM_GOALS } from "@src/shared/lib/analytics/yandex/constants";

import styles from "./RegistrationSuccessPage.module.scss";

export const RegistrationSuccessPage = () => {
  const navigate = useNavigate();
  
  useEffect(() => { 
   reachGoal(YM_GOALS.REGISTRATION_SUCCESS); 
 }, []); 

 const goToMain = () => { 
   reachGoal(YM_GOALS.GO_TO_MAIN); 

   navigate("/"); 
 };

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.block}>
          <img src={logo} alt="Логотип" className={styles.logo} />

          <div className={styles.titleWrap}>
            <span className={styles.title}>
              Сервис по найму сотрудников 24/7
            </span>
          </div>
        </div>
      </header>

      <main className={styles.content}>
        <div className={styles.cardBox}>
          <h1 className={styles.cardTitle}>Благодарим вас за регистрацию!</h1>

          <p className={styles.cardSubtitle}>
            Вы успешно создали аккаунт в Naimus.AI. Теперь вы можете перейти на
            главную страницу и выполнить первый запрос.
          </p>

          <div className={styles.btnWrap}>
            <Button onClick={goToMain} className={styles.btn}>
              Перейти на главную
            </Button>
          </div>
        </div>
      </main>

      <footer className={styles.footerWrapper}>
        <div className={styles.wrapperText}>
          <span className={styles.text}>© 2025 ООО «Цифра Лаб»</span>
        </div>

        <img src={wave} alt="wave" className={styles.wave} />
      </footer>
    </div>
  );
};
